// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__xb_bO","inputWrap":"Table_inputWrap___nqSW","col":"Table_col__3T3Qn","bmiTooltip":"Table_bmiTooltip__aL1I_"};